import React from 'react';

import ClockIcon from 'images/pu/products/usa_pcb_assembly/icons_clock.svg'
import map from 'images/pu/products/mx_pcb_assembly/map.png'

const HowItWorks = () => {
  return <>
    <div className="how-it-works">
      <div className="container">
        <div className="row no-gutters">
          <div className="col-12 col-lg-6">
            <h3 className="pt-3">How does it work?</h3>
            <ul>
              <li className="mb-3">All the material (PCBs and electronic components) are shipped to Calexico in the USA.</li>
              <li className="mb-3">The material is transported by land to Mexicali across the border.</li>
              <li className="mb-3">Your boards are assembled in Mexicali at a much lower cost.</li>
              <li className="mb-3">The assembled boards are transported back to Calixico and ship domestically to your location.</li>
            </ul>
          </div>
          <div className="col-12 col-lg-6 d-flex justify-content-center">
            <img src={map} alt="Calexico Map" className="img-fluid p-3" />
          </div>
        </div>
      </div>
    </div>

    <div className="assembly-clock">
      <div className="container">
        <div className="d-flex align-items-center">
          <div>
            <img src={ClockIcon} alt="Assembly Clock" />
          </div>
          <div>
            The Assembly Clock starts ticking the day after the PCBs,
            all the parts and required files are received.
          </div>
        </div>
      </div>
    </div>
  </>
}

export default HowItWorks;